export const ASSETS = {
  // COMMON: all games have these assets and the ids and paths are the same for all games. Do not alter this section at all
  logos: {
    title: {
      path: 'assets/title.png',
      width: 200,
      height: 80
    },
    playStore: {
      path: 'assets/play_store.png',
      width: 120,
      height: 50
    },
    appStore: {
      path: 'assets/app_store.svg',
      width: 120,
      height: 50
    }
  },
  backgrounds: {
    boxArt: {
      path: 'assets/backgrounds/box_art.png',
      width: 390,
      height: 844
    },
    background: {
      path: 'assets/backgrounds/background.png',
      width: 390,
      height: 844
    },
    mapBackground: {
      path: 'assets/backgrounds/map_background.png',
      width: 390,
      height: 844
    },
    profileBackground: {
      path: 'assets/backgrounds/profile_background.png',
      width: 390,
      height: 844
    },
    levelsBackground: {
      path: 'assets/backgrounds/levels_background.png',
      width: 390,
      height: 844
    },
    storyOverlayBackground: {
      path: 'assets/backgrounds/story_overlay_background.png',
      width: 390,
      height: 844
    }
  },
  // LOCATIONS: these are used for the background of battles, banners, story, etc.
  locations: {
    subway: {
      path: 'assets/locations/subway.png',
      width: 390,
      height: 844
    }
  },
  // CHARACTERS: these represent the characters in the game
  splashes: {
    kareena: {
      path: 'assets/characters/kareena.png',
      width: 416,
      height: 624
    }
  },
  portraits: {
    kareena: {
      path: 'assets/characters/kareena.png',
      width: 416,
      height: 624
    }
  },
  characters: {
    kareena: {
      path: 'assets/characters/kareena.png',
      width: 80,
      height: 120
    }
  },
  speakers: {
    kareena: {
      path: 'assets/characters/kareena.png',
      width: 416,
      height: 624
    },
    elder: {
      path: 'assets/characters/elder.png',
      width: 416,
      height: 624
    },
    architect: {
      path: 'assets/characters/architect.png',
      width: 416,
      height: 624
    },
    builder: {
      path: 'assets/characters/builder.png',
      width: 416,
      height: 624
    },
    merchant: {
      path: 'assets/characters/merchant.png',
      width: 416,
      height: 624
    },
    craftsman: {
      path: 'assets/characters/craftsman.png',
      width: 416,
      height: 624
    },

    /* ADDED TWO NEW CHARACTERS BELOW */
    scout: {
      path: 'assets/characters/scout.png',
      width: 416,
      height: 624
    },
    chef: {
      path: 'assets/characters/chef.png',
      width: 416,
      height: 624
    }
  },
  // BATTLE SPRITES: All characters and enemies should be here and sizes should be 80x120
  sprites: {
    kareena: {
      path: 'assets/characters/kareena.png',
      width: 80,
      height: 120
    },
    'hotdog-maker': {
      path: 'assets/characters/hotdog-maker.png',
      width: 80,
      height: 120
    },
    'influencer': {
      path: 'assets/characters/influencer.png',
      width: 80,
      height: 120
    },
    'statue-of-liberty': {
      path: 'assets/characters/statue-of-liberty.png',
      width: 80,
      height: 120
    }
  },
  // ITEMS: All items including weapons armor etc. should be here and sizes should be 512x512
  items: {
    greatSword: {
      path: 'assets/items/great-sword.png',
      width: 512,
      height: 512
    },
    powerShield: {
      path: 'assets/characters/power-shield.png',
      width: 512,
      height: 512
    }
  },
  // RESOURCES: The energy, currency, and primary currency should be listed here by id
  resources: {
    energy: {
      path: 'assets/icons/energy.png',
      width: 512,
      height: 512
    },
    spaceCoins: {
      path: 'assets/icons/spaceCoins.png',
      width: 512,
      height: 512
    },
    grandGems: {
      path: 'assets/icons/grandGems.png',
      width: 512,
      height: 512
    }
  },
  // UI: UI elements like buttons
  ui: {
    buttonBackground: {
      path: 'assets/ui/button_background.png',
      width: 119,
      height: 51
    },
    hudBackground: {
      path: 'assets/ui/hud_background.png',
      width: 390,
      height: 70
    },
    indicatorBackground: {
      path: 'assets/ui/indicator_background.png',
      width: 73,
      height: 24
    },
    plusButton: {
      path: 'assets/ui/plus_button.png',
      width: 13,
      height: 13
    },
    // New shop assets
    shopBackground: {
      path: 'assets/ui/shop_background.png',
      width: 345,
      height: 438
    },
    closeButton: {
      path: 'assets/ui/close_button.png',
      width: 14,
      height: 16
    },
    shopButtonBar: {
      path: 'assets/ui/shop_button_bar.png',
      width: 345,
      height: 60
    },
    selectedButton: {
      path: 'assets/ui/selected_button.png',
      width: 96,
      height: 33
    },
    unselectedButton: {
      path: 'assets/ui/unselected_button.png',
      width: 96,
      height: 33
    },
    itemCardBackground: {
      path: 'assets/ui/item_card_background.png',
      width: 126,
      height: 194
    },
    buyButton: {
      path: 'assets/ui/buy_button.png',
      width: 108,
      height: 30
    },
    // New profile assets
    profileFrameOutline: {
      path: 'assets/ui/profile_frame_outline.png',
      width: 170,
      height: 170
    },
    // New task modal assets
    tasksBackground: {
      path: 'assets/ui/tasks_background.png',
      width: 370,
      height: 547
    },
    buildButton: {
      path: 'assets/ui/build_button.png',
      width: 108,
      height: 30
    },
    // New grid cell asset
    gridCell: {
      path: 'assets/ui/grid_cell.png',
      width: 65,
      height: 65
    },
    // New level screen assets
    playButton: {
      path: 'assets/ui/play_button.png',
      width: 66,
      height: 28
    },
    lockedButton: {
      path: 'assets/ui/locked_button.png',
      width: 66,
      height: 28
    },
    // New story overlay assets
    dialogueBackground: {
      path: 'assets/ui/dialogue_background.png',
      width: 390,
      height: 220
    },
    nextButton: {
      path: 'assets/ui/next_button.png',
      width: 27,
      height: 31
    },
    // Bottom nav icons
    ui_levels: {
      path: 'assets/ui/ui_levels.png',
      width: 46,
      height: 46
    },
    ui_ranking: {
      path: 'assets/ui/ui_ranking.png',
      width: 46,
      height: 46
    },
    ui_map: {
      path: 'assets/ui/ui_map.png',
      width: 46,
      height: 46
    },
    ui_profile: {
      path: 'assets/ui/ui_profile.png',
      width: 46,
      height: 46
    },
    ui_shop: {
      path: 'assets/ui/ui_shop.png',
      width: 46,
      height: 46
    }
  }
};
